import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
 */

@Pipe({
    name: 'splitColumnNameTooltip',
    standalone: true
})
export class SplitColumnNameTooltipPipe implements PipeTransform {
  transform(value: string, attributeToGet: 'title' | 'name' = 'name'): string {
    const [name, title] = value.split(' | ');
    if (attributeToGet === 'title') {
      return title || name;
    }
    return name;
  }
}
